import React, { PureComponent, Fragment } from 'react';
import cn from 'classnames';
import { withApollo } from 'react-apollo';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import CourseResource from 'legacy/packages/unit-outline/src/components/_shared/CourseResource';
import ResourceTypes from 'legacy/packages/unit-outline/src/constants';
import { ItemAction } from '../ItemAction';
import { shareResourceToClass } from 'legacy/src/utility/helpers';
import { stateLabels } from './constants';
import {
  detectAvailableProgress,
  detectUnlockedStatus,
  renderAssessmentProgress as renderAssessmentProgressUtil,
} from './util';

import './SubunitResources.scss';

export class SubunitResources extends PureComponent {
  static displayName = 'SubunitResources';

  static propTypes = {
    unitIsShareable: PropTypes.bool.isRequired,
    resources: PropTypes.array.isRequired,
    unitNumber: PropTypes.string.isRequired,
    subunitNumber: PropTypes.string.isRequired,
    unitId: PropTypes.string.isRequired,
    isPreApSubject: PropTypes.bool.isRequired,
    unitTitle: PropTypes.string,
    unitsLabel: PropTypes.string,
  };

  static defaultProps = {
    unitTitle: null,
    unitsLabel: null,
  };

  renderAssessmentProgress = (
    isProgressAvailable,
    assignmentsForResource,
    displayName,
    resource,
  ) => {
    const { isAdminOrCoordinator, subjectId, isPPC, isPreApSubject } =
      this.props;
    return renderAssessmentProgressUtil(
      isProgressAvailable,
      assignmentsForResource,
      displayName,
      resource,
      isAdminOrCoordinator,
      subjectId,
      isPPC,
      isPreApSubject,
    );
  };

  render() {
    let {
      resources,
      unitIsShareable,
      isStudent,
      unitId,
      subjectId,
      unitNumber,
      unitTitle,
      subunitNumber,
      metadata,
      assignments,
      widgetTagColumn,
      unitsLabel,
      isPreApSubject,
      isAdminOrCoordinator,
      isPPC,
      useClassroomResourceAddress,
    } = this.props;

    const partnerResources = (resources || []).filter(
      (r) => r.__typename === ResourceTypes.PARTNER_LINK,
    );
    const distanceResources = (resources || []).filter(
      (r) => r.__typename === ResourceTypes.DISTANCE_LINK,
    );
    // filter out the groups. they should be represented as sub units. also the partner links are treated separately.
    resources = (resources || []).filter(
      (r) =>
        r.__typename !== ResourceTypes.PARTNER_LINK &&
        r.__typename !== ResourceTypes.DISTANCE_LINK &&
        r.__typename !== ResourceTypes.GROUP,
    );

    const renderResource = (resource) => {
      const {
        id,
        assessmentId,
        displayName,
        __typename: resourceTypeName,
      } = resource;
      let assignmentsForResource = [];
      if (!isStudent) {
        assignmentsForResource = (assignments || []).filter(
          (assignment) =>
            assignment.assessment.itemId === resource.assessmentId,
        );
        assignmentsForResource = assignmentsForResource.sort(
          (assignmentA, assignmentB) =>
            assignmentA.sectionName > assignmentB.sectionName ? 1 : -1,
        );
      }

      const isProgressAvailable = detectAvailableProgress(
        isStudent,
        assignmentsForResource,
        assessmentId,
      );
      const isPracticeQuestionsResource =
        resourceTypeName === ResourceTypes.PRACTICE_QUESTIONS;

      const assessmentProgressComponent = this.renderAssessmentProgress(
        isProgressAvailable,
        assignmentsForResource,
        displayName,
        resource,
      );

      const isUnlocked = detectUnlockedStatus(
        assignmentsForResource,
        assessmentId,
        isAdminOrCoordinator,
        assessmentProgressComponent,
        isPPC,
        isPreApSubject,
      );

      return (
        <li
          key={`list-${id}`}
          className={cn({ 'topic-question': isPracticeQuestionsResource })}
          data-test-tr-resource
        >
          <CourseResource
            isUnlocked={isUnlocked}
            unitTitle={unitTitle}
            unitsLabel={unitsLabel}
            isStudent={isStudent}
            scope={[
              'units',
              `unit-${unitId}`,
              'resources',
              `resource-${id}-subject-${subjectId}`,
            ]}
            resource={resource}
            subject={subjectId}
            unitNumber={unitNumber}
            subunitNumber={subunitNumber}
            key={`resources-${id}`}
            metadata={metadata}
            widgetTagColumn={widgetTagColumn}
            useClassroomResourceAddress={useClassroomResourceAddress}
            itemAction={
              !isPreApSubject && (
                <ItemAction
                  hasAssignAction
                  showLabel={false}
                  stateLabels={stateLabels}
                  item={resource}
                  unitNumber={Number(unitNumber)}
                  scope={['custom-action']}
                />
              )
            }
          >
            {assessmentProgressComponent}
            {
              <ItemAction
                isPreApSubject={isPreApSubject}
                disabled={unitIsShareable}
                stateLabels={stateLabels}
                item={resource}
                unitNumber={Number(unitNumber)}
                save={shareResourceToClass}
                scope={[
                  'units',
                  `unit-${unitId}`,
                  'resources',
                  `resource-${id}-subject-${subjectId}`,
                ]}
                unitTitle={unitTitle}
                useClassroomResourceAddress={useClassroomResourceAddress}
                subject={subjectId}
              />
            }
          </CourseResource>
        </li>
      );
    };

    return (
      <div className="subunit-resources">
        <ul>{resources.map((resource) => renderResource(resource))}</ul>
        {partnerResources && partnerResources.length ? (
          <Fragment>
            <div className="partner-resource-subtitle">PARTNER RESOURCES</div>
            <div className="partner-resource-container">
              <ul
                className="partner-resource-list"
                data-test-tr-partner-resource
              >
                {partnerResources.map((resource) => renderResource(resource))}
              </ul>
            </div>
          </Fragment>
        ) : null}
        {distanceResources && distanceResources.length ? (
          <Fragment>
            <div className="distance-resource-subtitle">
              DISTANCE LEARNING RESOURCES
            </div>
            <div className="distance-resource-container">
              <ul
                className="distance-resource-list"
                data-test-tr-distance-resource
              >
                {distanceResources.map((resource) => renderResource(resource))}
              </ul>
            </div>
          </Fragment>
        ) : null}
      </div>
    );
  }
}

export default withApollo(withRouter(SubunitResources));
